import axios from 'axios'
// import { getToken } from './token'
import signMd5Utils from '@/utils/encryption/signMd5Utils'
import { getDateTimeToString } from '@/utils/utils'
import { baseURL } from './config'
const request = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

request.interceptors.request.use(
  (config) => {
    const url = config.baseURL + config.url
    const sign = signMd5Utils.getSign(url, { ...config.data, ...config.params })
    config.headers = {
      'X-Access-Token': '',
      'X-Sign': sign,
      'X-TIMESTAMP': getDateTimeToString()
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      return res.data
    }
    if (res.status === 500) {
      return Promise.reject(res.data)
    }
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default request
